import * as React from 'react';
import type { ServiceOrder } from 'contracts/service-orders';
import { Box } from 'components/ui/Box';
import { cn } from 'lib/utils';
import { Formatter } from 'utils/Formatter';

type Props = React.ComponentProps<'div'> & {
  order: ServiceOrder
}

export const CanceledOrderStatusBox = ({ order, className, ...props }: Props) => {
  const { canceledByUser, canceledAt, cancellationReason } = order;

  if (!canceledByUser || !canceledAt) return null;

  return (
    <Box className={cn('flex flex-col gap-2 py-4 bg-amber-100 text-amber-700 text-sm', className)} {...props}>
      <p>
        Ordem cancelada por <span className={'font-GilroySemibold'}>{canceledByUser?.name}</span>
        {' '} em <span className={'font-GilroySemibold'}>{Formatter.dateFull(canceledAt)}</span>
      </p>
      {cancellationReason && (
        <p><span className={'font-GilroySemibold'}>Justificativa:</span> {cancellationReason}</p>
      )}
    </Box>
  );
};